import { startApp } from "./common/js/du/AppStartup";
import {
  tryStartContentDesigner,
  tryStartContentPlacements,
} from "./common/js/du/components/utility/content/designer/contentDesignerBootstrap";
import { execLegacyS1Func } from "./common/js/legacy/LegacyAppStartup";

window["startS1App"] = startApp;
window["execLegacyS1Func"] = execLegacyS1Func;

tryStartContentDesigner();
tryStartContentPlacements();
